export default function () {
  var template = _.template($('#template-account-detail').html());
  var formTemplate = _.template($('#template-account-detail-form').html());

  $('.account-details').each(function() {
    var detailsBox = $(this);
    $.ajax({
      url: $(this).data('url'),
      type: 'get',
      success: function (data) {
        detailsBox.html();
        for (var i=0; i < data.length; i++) {
          renderDetail(detailsBox, data[i]);
        }
      }
    });
  });

  var renderDetail = function(detailsBox, data) {
    var vars = {
      type: data.type,
      value: data.value,
      description: data.description,
    };
    if (data.type == 2) {
      vars.url = formatUrl(data.value);
    }
    detailsBox.append(template(vars));
  };

  var formatUrl = function(value) {
    return value.indexOf('://') === -1 ? '//'+value : value;
  };

  var renderDetailForm = function(detailsBox) {
    detailsBox.append(formTemplate({
      url: detailsBox.data('add-url'),
    }));
  };

  $('.add-account-detail').click(function(e) {
    e.preventDefault();
    renderDetailForm($(this).parents('.account-details-wrapper').children('.account-details'));
  });

  // cancel adding a new detail
  $('.account-details').on('click', '.cancel', function(e) {
    e.preventDefault();
    $(this).parents('.add-detail-form').remove();
  });

  $('.account-details').on('click', '.save', function(e) {
    e.preventDefault();

    var form = $(this).parents('.add-detail-form');
    var description = form.find('textarea').val();
    var type = form.find('select').val();
    var value = form.find('input').val();

    $.ajax({
      url: form.data('url'),
      type: 'post',
      data: {
        type: type,
        value: value,
        description: description,
      },
      success: function (data) {
        renderDetail(form.parents('.account-details'), data);
        form.remove();
      }
    });

  });

};



// WEBPACK FOOTER //
// ./assets/js/account-details.js